'use client'
import AstTool from './ast-tool'
import styles from './styles.module.css'

export default function Discover({ dict }) {
    const { discover_more } = dict.discover;
    const astTitle = dict.ast_tool?.tool_name || 'Alignment Screen Tool';

    return (
        <div id={'discover'} className={styles.discover} data-name="discover">
            <div className={styles.discover__image_block}>
                <div className={styles.discover__slider}>
                    <div className={styles.discover__ces_bg}>
                        <div className={styles.discover__slide_content}>
                            <div>
                                <div className={styles.discover__slide_title} style={{ whiteSpace: 'pre-line' }}>{astTitle}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.discover__text_block}>
                <AstTool dict={dict} />
            </div>
        </div>
    );
}
